








































































import { Component, Vue } from 'vue-property-decorator'
import { throttle } from 'lodash-es'
import ClickOutside from 'vue-click-outside'
import { Action, Getter } from 'vuex-class'
import IUser from '@/models/IUser'
import { COFFEE_LINK } from '@/utils/constants'

@Component({
  directives: {
    ClickOutside
  },
  components: {
    'online-view': () => import('@/components/OnlineView.vue'),
    'queue-notif': () => import('@/components/QueueNotif.vue')
  }
})
export default class App extends Vue {
  @Getter
  public user!: IUser | null
  @Getter
  public username!: string
  @Getter
  public title!: string | null
  public menuOpen: boolean = false
  public transitionName: string = ''
  public shadow: boolean = false
  public coffee: string = COFFEE_LINK

  public mounted(): void {
    const main = document.getElementById('main')
    if (main) {
      this.shadow = main.getBoundingClientRect().top < 0
      document.addEventListener(
        'scroll',
        throttle((evt) => {
          this.shadow = main.getBoundingClientRect().top < 0
        }, 150)
      )
    }
  }

  public toggleMenu(): void {
    this.menuOpen = !this.menuOpen
  }

  public hideMenu(): void {
    this.menuOpen = false
  }

  public back(): void {
    window.history.back()
  }
}
